import { render } from "./IndexConfig.vue?vue&type=template&id=569a69a4&scoped=true"
import script from "./IndexConfig.vue?vue&type=script&lang=js"
export * from "./IndexConfig.vue?vue&type=script&lang=js"

import "./IndexConfig.vue?vue&type=style&index=0&id=569a69a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-569a69a4"]])

export default __exports__